
import Ace from "@/components/helpers/ace.vue"
import { Vue, Component } from "vue-property-decorator";
import ObjectDataTable from "@/components/helpers/object-data-table.vue";
import {
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiMinus,
  mdiPen,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiTrashCan,
} from "@mdi/js";
import editor from "./editor";
import axios from "axios";
import { getClassCaption } from "@/cms-services/helpers";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";

@Component({
  mixins: [editor],
  components: { ObjectDataTable, Ace },
})
class ProductLinkInlineEditor extends Vue {
    tab = null
    dialog = false;
    dialog1 = false
    dataSource:any
    getClassCaption = getClassCaption;
    selectedItem = null
    icons: any = {
        plus: mdiPlus,
        minus: mdiMinus,
        pen: mdiPen,
        trash: mdiTrashCan,
        search: mdiMagnify,
        dotsVertical: mdiDotsVertical,
        circlePlus: mdiPlusCircleOutline,
        folderOpen: mdiFolderOpen,
        folder: mdiFolder,
    };
    loaded = false;
    strValue: string = "";
    value: any;
    loading1 = false;
    loading2 = false;
    fromOthersToSelfLinks:any[] = [];
    fromSelfToOthersLinks:any[] = [];
    component:any = {};

    seoItemDatasource   = new ListDataSource({
        className:"ComponentSeoItem",
        config:{}
    })
    message: any;

    async loadComponent(id:number){
        const {data} = await axios.get(`/manage/component/${id}/`);
        this.component = data;
    }
    

    async loadSeoItem(id:number){
        this.seoItemDatasource.config.filter = JSON.stringify([
            new Filter("componentId",id)
        ])

        await this.seoItemDatasource.get();
    }

    sleep(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async generateFromSelfToOthersLinks(){
        this.loading1 = true
        await axios.post(`/manage/component/${this.dataSource.id}/relink/from/self/to/others/`);
        await this.sleep(1000)
        await this.dataSource.get();
        this.loading1 = false

        this.message("Ссылки от меня успешно сгенерированы")
    }

    async generateFromOthersToSelfLinks(){
        this.loading2 = true
        await axios.post(`/manage/component/${this.dataSource.id}/relink/from/others/to/self/`);
        await this.sleep(1000)
        await this.dataSource.get();
        this.loading2 = false
        this.message("Ссылки от меня успешно сгенерированы")
    }

    async mounted() {
        try {
            const [self, others] = await Promise.all([
                axios.get(`/manage/${this.dataSource.className}/${this.dataSource.id}/link/from/self/to/others/`),
                axios.get(`/manage/${this.dataSource.className}/${this.dataSource.id}/link/from/others/to/self/`)
            ]);

            this.fromOthersToSelfLinks = others.data;
            this.fromSelfToOthersLinks = self.data;
        } catch (error) {
            console.error('Ошибка загрузки ссылок:', error);
        } finally {
            this.loaded = false;
        }
    }

}

const __default__ = ProductLinkInlineEditor
import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars((_vm, _setup) => ({
  "73d07a36": (_vm.dataSource.id)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__